<template>
  <input
    v-model.number="localValue"
    type="number"
    :readonly="readOnly"
    :aria-readonly="readOnly"
    :aria-placeholder="placeholder"
    :placeholder="placeholder"
    :aria-describedby="placeholder"
    :disabled="disabled"
    :class="[$style.input, { [$style.disabled]: disabled }]"
    @update:modelValue="$emit('update:modelValue', localValue ?? 0)"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    modelValue?: number
    /** プレースホルダー */
    placeholder?: string
    /** 非活性 */
    disabled?: boolean
    /** 読み取り専用 */
    readOnly?: boolean
  }>(),
  {
    modelValue: undefined,
    placeholder: "",
    disabled: false,
    readOnly: false,
  },
)

const emit = defineEmits<{
  (e: "update:modelValue", modelValue: number): void
}>()

const localValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    if (typeof value === "number") emit("update:modelValue", value)
  },
})
</script>

<style scoped module lang="scss">
@import "./AtomsConsumer";
.input {
  @include text-style;
}
</style>
